export const gakkiNames = [
  '春A',
  '春B',
  '春C',
  '秋A',
  '秋B',
  '秋C',
  // '夏季休業中',
  // 'その他',
] as const
// typeofで文字列リテラルユニオン型を定義
export type gakkiNameType = (typeof gakkiNames)[number]
// チェックする関数定義 ユーザー定義の型ガード
export const isGakkiName = (value: any): value is gakkiNameType => {
  return Object.values(gakkiNames).includes(value)
}

const notGakkiNames = ['その他'] as const
export type notGakkiNamesType = (typeof notGakkiNames)[number]
export const isNotGakkiNames = (value: any): value is notGakkiNamesType => {
  return Object.values(notGakkiNames).includes(value)
}

export type gakki = {
  [key in notGakkiNamesType]: string[][]
}
export type notGakki = {
  [key in gakkiNameType]: weekType
}
export type ryoiki = notGakki & gakki

export const weekDays = ['月', '火', '水', '木', '金', '土'] as const
export type weekDaysType = (typeof weekDays)[number]
export const isWeekDays = (value: any): value is weekDaysType => {
  return Object.values(weekDays).includes(value)
}

const notWeekDays = ['指定なし'] as const
export type notWeekDaysType = (typeof notWeekDays)[number]
export const isNotWeekDays = (value: any): value is notWeekDaysType => {
  return Object.values(notWeekDays).includes(value)
}

export type weekType = {
  [key in weekDaysType]: yojigen
}
export type notWeekType = {
  [key in notWeekDaysType]: shiteinashi
}

export type weekAndOtherType = weekType & notWeekType

export const jigens = [1, 2, 3, 4, 5, 6] as const
export type jigensType = (typeof jigens)[number]
export const isJigens = (value: any): value is jigensType => {
  return Object.values(jigens).includes(value)
}

const jigenAfters = ['over'] as const
export type jigenAftersType = (typeof jigenAfters)[number]
export const isJigenAfters = (value: any): value is jigenAftersType => {
  return Object.values(jigenAfters).includes(value)
}

export type yojigenDaytimeType = {
  [key in jigensType]: jigen
}
export type yojigenAfterTimeType = {
  [key in jigenAftersType]: jigen
}
export type yojigen = yojigenDaytimeType & yojigenAfterTimeType

export type shiteinashi = []
// export type shiteinashiKikan = '集中' | '随時' | '応談'

// export type jigen = []
// export type jigen = string[]
export type jigen = string[][]
